import React from "react";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";
import { SiReact,SiHuawei ,SiCisco, SiFigma, SiLaravel } from "react-icons/si";
const LeftBanner = () => {
  const [text] = useTypewriter({
    words: [
      "Graphic Designer.",
      "Network Engineer + Cyber Security Specialist.",
      "Flutter Developer.",
      "Full Stack Web Developer.",
      "Data Analyst.",
    ],
    loop: true,
    typeSpeed: 20,
    deleteSpeed: 10,
    delaySpeed: 2000,
  });
  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-3">
        <h4>WELCOME TO MY PORTFOLIO WEBSITE</h4>
        <h1 className="text-4xl font-bold text-white">
          Hi, I'm{" "}
          <span className="text-designColor capitslizer"> Maxon Gomeka</span>
        </h1>
        <h2 className="text-2xl font-bold text-white">
          a <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle=" "
            cursorColor="#ff014f"
          />
        </h2>
        <p className="text-base font-bodyFont leading-5 tracking-wide">
          My mission is to provide my customers with the best quality of
          services with a market-oriented approach to achieve their bussiness
          goals. Henceforth, My brand can grow smoothly.💻👁️🔥
        </p>
      </div>
      <div className="flex flex-col xl:flex-row gap-6 xl:gap-0 justify-between w-full">
        <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
            Find me on
          </h2>
          <div className=" flex gap-4">
            <span className="bannerIcon">
            <a href="https://m.facebook.com/people/Macheda-Graphics/100083311030390/">
                      <FaFacebook />
                    </a>
            </span> 
            <span className="bannerIcon">
              <FaInstagram />
            </span>
            <span className="bannerIcon">
              <FaTwitter />
            </span>
            <span className="bannerIcon">
              <FaLinkedin />
            </span>
          </div>
        </div>
        
        <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
            BEST SKILL IN
          </h2>
          <div className=" flex gap-4">
            <span className="bannerIcon">
              <SiReact />
            </span>
            <span className="bannerIcon">
              <SiFigma />
            </span>
            <span className="bannerIcon">
              <SiCisco />
             
            </span>
            <span className="bannerIcon">
              <SiHuawei/>
            </span>
            <span className="bannerIcon">
              <SiLaravel />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftBanner;
